import { getMetadata } from '~loader/loader-utils';
import slugify from 'slugify';
import Swal from 'sweetalert2';
import { generateVideo } from '~video';
import { saveAs } from 'file-saver';

export const saveMP4 = async () => {
  const metadata = getMetadata();

  const fileName = slugify(
    `${metadata.projectTypeName}${
      metadata.templatesCategoryName ? `-${metadata.templatesCategoryName}` : ''
    }${metadata.servizioName ? `-${metadata.servizioName}` : ''}${
      metadata.formatName ? `-${metadata.formatName}` : ''
    }.mp4`
  );

  const videoResponse = await generateVideo({ isPreview: false });

  saveAs(videoResponse.video.url, fileName);

  Swal.hideLoading();
  Swal.fire({
    title: 'Fatto!',
    html: 'Il video &egrave; stato scaricato.',
    icon: 'success',
    confirmButtonColor: '#278e8e',
  });
};
